import { DevelopmentPageProvider } from "../../context/DevelopmentPageContext";
import ServicePageLayout from "./ServicePageLayout";

export default function Development() {
  return (
    <DevelopmentPageProvider>
      <ServicePageLayout />
    </DevelopmentPageProvider>
  );
}
